import { createContext } from 'react';

import { Store } from './types.js';

export const StoreContext = createContext<Store | null>(null);
